import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule, TranslateLangPipe } from '@gs-2.0/shared';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';

import { PortalCoreModule } from '../../_core/core.module';
import { PortalSharedModule } from '../../_shared/shared.module';
import { RecurringFormComponent } from '../../_shared/recurring-form/recurring-form.component';
import { GrantFormComponent } from './form/form.component';
import { GrantSummaryComponent } from './summary/summary.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PortalCoreModule,
    PortalSharedModule,
    SharedModule,
    TranslateLangPipe,
    AutoCompleteModule,
    RadioButtonModule,
    CheckboxModule,
    DatePickerModule,
    InputNumberModule,
    RecurringFormComponent,
  ],
  declarations: [GrantFormComponent, GrantSummaryComponent],
  exports: [GrantFormComponent, GrantSummaryComponent],
})
export class GrantComponentsModule {}
